var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_1805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3563 25.3937H6.47704V12.9013H10.3563V25.3937ZM8.41461 11.1972C7.17413 11.1972 6.16797 10.1697 6.16797 8.92925C6.16797 8.33341 6.40467 7.76197 6.82599 7.34064C7.24732 6.91932 7.81876 6.68262 8.41461 6.68262C9.01045 6.68262 9.58189 6.91932 10.0032 7.34064C10.4245 7.76197 10.6612 8.33341 10.6612 8.92925C10.6612 10.1697 9.65466 11.1972 8.41461 11.1972ZM24.8753 25.3937H21.0044V19.3125C21.0044 17.8632 20.9751 16.0046 18.9875 16.0046C16.9705 16.0046 16.6615 17.5792 16.6615 19.2081V25.3937H12.7863V12.9013H16.5069V14.6054H16.5612C17.0791 13.6238 18.3443 12.588 20.2317 12.588C24.1578 12.588 24.8795 15.1734 24.8795 18.5314V25.3937H24.8753Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_1805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7115,
    height: 21.3846,
    fill: "white",
    transform: "translate(6.16797 5.34619)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ca1e10c8a265025e3520e7a0a83a47c0.svg";
export { ForwardRef as ReactComponent };